import "../../pages/recall-details.css";
import { convertInMonthNameFormat } from "../../utils/helper";
import PropTypes from "prop-types";
import { RenderRichText } from "./render-rich-text";

export const AutoComponent = ({
  item,
  showContainer = true,
  showRestData = true
}) => {
  const hasRichData = Boolean(item?.rich_text_enabled);
  return (
    <>
      {showContainer && (
        <div
          style={{
            backgroundColor: "#D5E4F0",
            borderRadius: "10px",
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            marginTop: "10px"
          }}>
          <h5 className="recall-summary">{item?.recall_title}</h5>
          <div style={{ display: "flex", flexWrap: "nowrap" }}>
            {item?.id && (
              <div className="col-sm-2">
                <div className="recall-details-card-item">
                  <span>{item.id}</span>
                  <span> Recall ID </span>
                </div>
              </div>
            )}
            {item?.created_on && (
              <div className="col-sm-2">
                <div className="recall-details-card-item">
                  <span>
                    {convertInMonthNameFormat(item.report_received_date)}
                  </span>
                  <span>Recall Date</span>
                </div>
              </div>
            )}
            {(item?.manufacturer || item?.make) && (
              <div className="col-sm-2">
                <div className="recall-details-card-item">
                  <span>{item.manufacturer || item.make}</span>
                  <span>Make</span>
                </div>
              </div>
            )}
            {item?.model && (
              <div className="col-sm-2">
                <div className="recall-details-card-item">
                  <span>{item.model}</span>
                  <span>Model</span>
                </div>
              </div>
            )}
            {item?.model_year && (
              <div className="col-sm-2">
                <div className="recall-details-card-item">
                  <span>{item.model_year}</span>
                  <span>Model Year</span>
                </div>
              </div>
            )}
            {item?.status && (
              <div className="col-sm-2">
                <div className="recall-details-card-item">
                  <span>{item.status}</span>
                  <span>Status</span>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {showRestData && (
        <>
          {item?.reason_for_recall && (
            <div className="recall-details-body-item">
              <h2>Reason for Recall</h2>
              <p>{item.reason_for_recall}</p>
            </div>
          )}
          {item?.summary && (
            <div className="recall-details-body-item">
              <h2>Summary</h2>
              {hasRichData ? (
                <RenderRichText text={item.summary} />
              ) : (
                <p>{item.summary}</p>
              )}
            </div>
          )}
          {item?.affected_products && (
            <div className="recall-details-body-item">
              <h2>Affected Products</h2>
              {hasRichData ? (
                <RenderRichText text={item.affected_products} />
              ) : (
                <p>{item.affected_products}</p>
              )}
            </div>
          )}
          {item?.affected_units && (
            <div className="recall-details-body-item">
              <h2>Affected Units</h2>
              <p>{item.affected_units}</p>
            </div>
          )}
          {item?.component && (
            <div className="recall-details-body-item">
              <h2>Component</h2>
              <p>{item.component}</p>
            </div>
          )}
          {item?.consequences && (
            <div className="recall-details-body-item">
              <h2>Consequences</h2>
              {hasRichData ? (
                <RenderRichText text={item.consequences} />
              ) : (
                <p>{item.consequences}</p>
              )}
            </div>
          )}
          {item?.remedy && (
            <div className="recall-details-body-item">
              <h2>Remedy</h2>
              {hasRichData ? (
                <RenderRichText text={item.remedy} />
              ) : (
                <p>{item.remedy}</p>
              )}
            </div>
          )}
          {item?.notes && (
            <div className="recall-details-body-item">
              <h2>Product Description</h2>
              <p>{item.notes}</p>
            </div>
          )}
          {item?.source && (
            <div className="recall-details-body-item">
              <h2>Source</h2>
               {hasRichData ? (
                <RenderRichText text={item.source} />
              ) : (
                <p>{item.source}</p>
              )}
            </div>
          )}
          {item?.recall_comments && (
            <div className="recall-details-body-item">
              <h2>Recall Comments</h2>
              <p>{item.recall_comments}</p>
            </div>
          )}
          {item?.vin_details && (
            <div className="recall-details-body-item">
              <h2>VIN Details</h2>
              <p>{item.vin_details}</p>
            </div>
          )}
          {item?.classification && (
            <div className="recall-details-body-item">
              <h2>Classification</h2>
              <p>{item.classification}</p>
            </div>
          )}
          {item?.parkit && (
            <div className="recall-details-body-item">
              <h2>Park It</h2>
              <p>{item.parkit}</p>
            </div>
          )}
          {item?.parkoutside && (
            <div className="recall-details-body-item">
              <h2>Park Outside</h2>
              <p>{item.parkoutside}</p>
            </div>
          )}
          {item?.link && (
            <div className="recall-details-body-item">
              <h2>Link</h2>
              <p>
                <a href={item.link} target="_blank" rel="noreferrer">
                  {item.link}
                </a>
              </p>
            </div>
          )}
          {item?.subject && (
            <div className="recall-details-body-item">
              <h2>Subject</h2>
              <p>{item.subject}</p>
            </div>
          )}
        </>
      )}
    </>
  );
};
AutoComponent.propTypes = {
  item: PropTypes.object.isRequired,
  showContainer: PropTypes.bool,
  showRestData: PropTypes.bool
};
